<template>
  <button
    type="button"
    class="w-full rounded-xl bg-[#FFB648] text-black-100 font-bold text-[16px] leading-[22px] h-[42px] p-2 shadow-sm hover:brightness-95 active:brightness-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FFB648]/50 disabled:opacity-50 disabled:cursor-not-allowed transition"
    :style="{ fontFamily: 'Satoshi, sans-serif', letterSpacing: '0px', fontStyle: 'bold' }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>{{ label }}</slot>
  </button>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label?: string;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const { t } = useI18n();

// Shadows the `label` prop so the template's bare `label` reference stays reactive to
// locale switches (a plain string default in `withDefaults` wouldn't be).
const label = computed(() => props.label ?? t('common.ctaButton.watchVideo'));

defineEmits<{
  (e: 'click'): void;
}>();
</script>
